var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-4 px-5",attrs:{"fluid":""}},[(_vm.verTicketsJefe)?_c('span',[_c('TicketAreaEspecial')],1):_vm._e(),(_vm.verTicketsAuxiliar)?_c('span',[_c('TicketAuxiEspecial')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }